import { useWC26PreTournamentOdds } from '../../queries';
import Spinner from '../Spinner/Spinner';
import './TeamListsWC26.css';

const TEAMS = ['team1', 'team2', 'team3', 'team4'] as const;

function TeamListsWC26() {
  const [loading, odds, error] = useWC26PreTournamentOdds();

  return (
    <div className="team-lists-wc26-container">
      <h2>Team Lists</h2>
      <p>Verified 2nd May 2026 (Paddy Power)</p>
      {error ? <p className="team-lists-wc26-error">Failed to load team lists.</p>
        : loading || !odds ? <Spinner />
          : (
            <div className="team-lists-wc26">
              {TEAMS.map((team, i) => (
                <div key={team} className="team-list-wc26">
                  <h3>{`Team ${i + 1}`}</h3>
                  <table>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Odds Winner</th>
                        <th>Odds Reach Final</th>
                      </tr>
                    </thead>
                    <tbody>
                      {odds[team].map((entry) => (
                        <tr key={entry.name}>
                          <td>{entry.name}</td>
                          <td>{entry.oddsWinner}</td>
                          <td>{entry.oddsReachFinal}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ))}
            </div>
          )}
    </div>
  );
}

export default TeamListsWC26;
